import React from 'react';

const EMPTY_STYLE = {};

const Skeleton = ({ width = '100%', height = 16, style = EMPTY_STYLE, className = '' }) => {
  const merged = { width, height, ...style };
  return <span className={`skeleton ${className}`.trim()} style={merged} aria-hidden="true" />;
};

export default Skeleton;
